/**
 * PencilIcon component - renders a pencil/edit icon as SVG
 * @returns React component that renders the pencil icon
 */
const PencilIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.75685 6.89961L5.09399 10.2382L9.64061 5.69279L6.30348 2.35419L1.75685 6.89961ZM11.7329 2.35419L9.64944 0.257662C9.30513 -0.0858873 8.74894 -0.0858873 8.40464 0.257662L7.15983 1.49972L10.497 4.83832L11.7418 3.59626C12.0861 3.25271 12.0861 2.68893 11.7418 2.34538L11.7329 2.35419ZM0 11.815L0.185396 12L4.25529 11.0839L0.918153 7.74527L0 11.815Z"
        fill="#616161"
      />
    </svg>
  );
};

export default PencilIcon;
